// Import required modules and configuration
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import * as msal from "@azure/msal-browser";
import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

import { API_ENDPOINT } from "./config/ApiConstants";
import { MSAL_CONFIG, MSAL_LOGINREQUEST } from "./config";
import { useLegacySupport } from "./components";
import { ToastContainer } from "react-toastify";


// Setting default headers for Axios HTTP client
axios.defaults.baseURL = API_ENDPOINT;
axios.defaults.headers.post['Content-Type'] = 'application/json';

// Main app component 
function App(props: any) {
  // Initialize the MSAL application client
  const msalInstance = new msal.PublicClientApplication(MSAL_CONFIG);

  const uiStates: any = useSelector<any>(state => state.uiStates);
  // State for authentication error
  const [authError, setAuthError] = useState<any>(null);

  const legacySupported = useLegacySupport();

  // Use useEffect to initialize MSAL upon component mounting
  useEffect(() => {
    if (!legacySupported.isLegacySupported) {
      // Call the MSAL initialization function if legacy token acquisition is not supported
      initializeMSAL();
    }
  }, [])

  // Async function to initialize MSAL
  const initializeMSAL = async () => {
    await msalInstance.initialize()

    // Attempt to perform Single Sign-On (SSO)
    await msalInstance.ssoSilent(MSAL_LOGINREQUEST).then((res) => {

      // Set the active account upon successful SSO
      msalInstance.setActiveAccount(res.account)

    }).catch((error) => {

      // Fallback to MSAL token acquisition if SSO fails
      msalCall()

    })
  }


  // Function to handle MSAL token acquisition via popup
  const msalCall = async () => {
    try {
      await msalInstance.acquireTokenPopup(MSAL_LOGINREQUEST).then((res) => {
        // Set the active account upon successful token acquisition
        msalInstance.setActiveAccount(res.account)
      });
    } catch (e) {
      // Set authentication error state if token acquisition fails
      setAuthError(e)
    }
  }


  // Main JSX for the App component
  return (
    <div className={uiStates.isPrintable ? "print" : "screen"}>
      <ToastContainer />
      {legacySupported.isLegacySupported ?
        <div className="legacySupported">
          {props.children}
        </div> :
        <MsalProvider instance={msalInstance}>
          {/* Render children components only if user is authenticated */}
          <AuthenticatedTemplate>
            {props.children}
          </AuthenticatedTemplate>


          {/* Display error message or authentication prompt if user is unauthenticated */}
          <UnauthenticatedTemplate>
            {authError !== null ? <div>
              <h3>Error: {JSON.stringify(authError)}</h3>
            </div> : <div>
              <h3>Authentication</h3>
              <p>Please use your login credentials</p>
            </div>}
          </UnauthenticatedTemplate>
        </MsalProvider>}
    </div>
  );
}

export default App;